<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            vuexStore: 'requestFiles',
            messageTitle: 'File Uploaded.',
            message: 'File has been successfully uploaded.',
            notificationType: 'success',
            firstAction: 'close',
            firstActionText: '&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showUploadFileSuccess'
        }
    },
}
</script>